export interface GtagConfig {
  measurementId: string
  debugMode: boolean
  shouldTrack: boolean
  isProduction: boolean
}

const getMeasurementId = (): string => {
  const gtagId = process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID

  if (!gtagId && process.env.NODE_ENV === 'production') {
    // GA4 Measurement ID not found in production environment
  }

  return gtagId || ''
}

const getDebugMode = (): boolean => {
  return process.env.NEXT_PUBLIC_GA4_DEBUG === 'true'
}

const getIsProduction = (): boolean => {
  return process.env.NODE_ENV === 'production'
}

const getShouldTrack = (): boolean => {
  const isProd = getIsProduction()
  const debugMode = getDebugMode()

  return isProd || debugMode
}

// Centralized configuration object
export const gtagConfig: GtagConfig = {
  measurementId: getMeasurementId(),
  debugMode: getDebugMode(),
  shouldTrack: getShouldTrack(),
  isProduction: getIsProduction()
}

// Validation function
export const validateGtagConfig = (): void => {
  if (gtagConfig.isProduction && !gtagConfig.measurementId) {
    // GA4 Measurement ID is required in production environment
  }

  if (gtagConfig.debugMode) {
    // Debug mode enabled
  }

  if (!gtagConfig.isProduction && gtagConfig.debugMode && !gtagConfig.measurementId) {
    // Debug mode enabled - events will be logged to console only
  }
}

// Export individual values for backward compatibility
export const GA4_MEASUREMENT_ID = gtagConfig.measurementId
export const GTAG_DEBUG_MODE = gtagConfig.debugMode
export const GTAG_SHOULD_TRACK = gtagConfig.shouldTrack
export const GTAG_IS_PRODUCTION = gtagConfig.isProduction
